<template>
  <!--  my work screen expects card component to be root of this component-->
  <card
    :no-shadow="noShadow"
    :padding="false"
    class="card-container"
    :class="{ expanded: isExpanded }"
  >
    <div>
      <div class="card-heading text-large bolder" :class="{ 'select-list-item': selectable }">
        <div class="d-flex align-items-center ml-n3">
          <collapse-caret class="mr-2" :expanded="isExpanded" @click="onClick" />
          <slot name="heading" v-if="$slots.heading" />
          <span v-else>{{ heading }}</span>
        </div>
      </div>
      <b-collapse class="expanded-section" v-model="isExpanded">
        <slot name="content" />
        <div class="message" v-if="$slots.message">
          <slot name="message" />
        </div>
      </b-collapse>
    </div>
  </card>
</template>

<script>
import ExpandCollapseMixin from '@/mixins/ExpandCollapseMixin'
import { clearSelection, selectItem } from '@/services/keymapService/keymapService'
import { BCollapse } from 'bootstrap-vue'
import Card from '@/components/Card'
import CollapseCaret from '@/components/CollapseCaret'

/**
 * This component gives a card layout, with collapse/expand capability.
 *
 * Slots available:
 *  - content
 *  - message
 */
export default {
  name: 'CollapsibleCard',
  props: {
    heading: String,
    expanded: Boolean,
    noShadow: Boolean,
    selectable: Boolean,
    contentSelectableSelectors: Array
  },
  mixins: [ExpandCollapseMixin],
  components: {
    Card,
    CollapseCaret,
    BCollapse
  },
  data() {
    return {
      isExpanded: typeof this.expanded === 'undefined' ? true : this.expanded
    }
  },
  methods: {
    onClick() {
      this.isExpanded = !this.isExpanded
      this.$emit('expand', this.isExpanded)
      if (this.selectable) {
        clearSelection()
        selectItem(this.$el.querySelector('.select-list-item'))
      }
    }
  },
  watch: {
    isExpanded(value) {
      if (this.contentSelectableSelectors) {
        this.contentSelectableSelectors.forEach(selector => {
          this.updateExpansion(value, selector, this.$el)
          this.updateExpansion(value, selector, this.$el)
        })
      }
    },
    expanded(value) {
      this.isExpanded = value
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/_styleConfigurations.scss';

.message {
  margin: 25px auto;
  text-align: center;
}

.card-heading {
  margin-bottom: 0;
  padding: 20px 25px;
}

.card-container {
  padding: 0;
}

.expanded-section {
  padding: 10px 25px 20px 25px;
}

.select-list-item.selected {
  background-color: $selectionColor;
}
.select-list-item {
  border-radius: 5px;
}
.expanded .select-list-item {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}
@include media-breakpoint-down(md) {
  .card-heading {
    padding: 15px 20px 15px 20px;
  }

  .expanded-section {
    padding: 8px 15px 20px 15px;
  }
}
</style>
